export const removeCountryName = (address?: string | null): string => (address ? address.split(/, \S+$/g)[0] : '');
